import {
  fileFormatRegex,
  requiredVatRegex,
  specialCharsRegex,
  upperLettersRegex,
} from '@/constants';

export const hasValidSize = (f: File): boolean => f.size / Math.pow(1024, 2) < 6;
export const hasValidFormat = (f: File): boolean => fileFormatRegex.test(f.type);
export const hasUpperLetter = (value: string): boolean => upperLettersRegex.test(value);
export const hasSpecialChar = (value: string): boolean => specialCharsRegex.test(value);
export const minLength = (value: string, length: number): boolean => value.length >= length;
export const shouldRequireVat = (countryCode = ''): boolean => requiredVatRegex.test(countryCode);
